;(function () {

"use strict";

var ConfigFormView = require('../views/config-form');

var PageView = Backbone.View.extend({
  initialize: function () {
    console.log('init config view');

    window.Buttons = {
      primary: {
        label: "Save Configuration",
        message: 'config_form_submit',
        loading: true,
        callback: function (message, data) {
          window.App.Events.trigger('submit');
        }
      }
    };

    if (window.data.isRedirect) {
      $('.back-btn').on('click', function (e) {
        // alert(window.parent.history);
        ShopifyApp.redirect(`products/${window.data.queryId}`);
        return false;
      });
    }

    console.log('init config form view');
    console.log(this.$el.find('form')[0]);

    new ConfigFormView({ el: this.$el.find('form') });
  }
});

module.exports = PageView;

}());